import { FormControlLabel, Stack, Switch, Typography } from '@mui/material'
import React, { useContext, useRef } from 'react'
import EPCRCard from '../../../../components/Cards/EPCRCard'
import { EPCRContext } from '../EPCR'
import Details from '../Incident/Details'
import HealthSafety from '../Incident/HealthSafety/HealthSafety'
import DemographicsModule from '../Demographics/Demographics'
import HistoryModule from '../History/History'
import SimpleTextField from '../../../../components/Forms/SimpleTextField'
import Treatment from '../Treatment/Treatment'
import FastTrackTreatment from './FastTrackTreatment'
import FastTrackPlan from './FastTrackPlan'
import ResponseTimes from '../Incident/ResponseTimes'
import TempReview from '../Review/TempReview'
import Attachments from '../Attachments/Attachments'

const FastTrackForm = () => {
  return (
    <Stack gap={1}>
      <Details />
      <HealthSafety />
      <DemographicsModule />
      <HistoryModule />
      <Attachments />
      <FastTrackTreatment />
      <FastTrackPlan />
      <ResponseTimes />
      <TempReview />
    </Stack>
  )
}

export default FastTrackForm
